import { Component } from '@angular/core';
import { SessionStat } from '../../../sessions/sessions-stat/sessions-stat.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { Globals } from '../../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { SuperClass } from '../../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-sms-accounting',
  templateUrl: './sms-accounting.component.html',
  styleUrls: ['./sms-accounting.component.css'],
})
export class SmsAccountingComponent extends SuperClass {
  selectedRow: SessionStat;
  display = false;
  displayReport = false;
  report = [[]];
  reportData = [[]];
  start: Date;
  end: Date;
  nasid;
  nasids;
  country;
  countries;
  searchType;
  searchTypes = [
    { description: 'By country' },
    { description: 'By NAS ID' },
    { description: 'By period' },
  ];
  allSMS;

  weeks;
  month;
  timeOpts;
  daysOfMonth;

  reportOpts = {
    selectedTimeOption: {timeWindow: '', description: ''},
    selectedWeek: {year: 0, week: 0},
    selectedMonth: {year: 0, month: 0},
    selectedDay: {dayOfYear: 0},
    start: 0 ,
    end: 0,
  };

  newSMSReportForm: FormGroup;
  session: SessionStat[];

  loading: string = 'none';

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      { label: 'Reporting' },
      {
        label: 'SMS Accounting',
        routerLink: [{ outlets: { sub: [RouterConst.SMS_ACCOUNTING] } }],
      },
    ]);
    this.selectedRow = new SessionStat();

    this.newSMSReportForm = this.fb.group({
      timeOpts: new FormControl('', Validators.required),
      week: new FormControl(),
      month: new FormControl(),
      days: new FormControl(),
      start: new FormControl(),
      end: new FormControl(),
    });
  }

  reloadData(): void {
    this.http_getNasidsForSMS((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.nasids = data.payload;
      }
    });
    this.http_getCountriesForSMS((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.countries = data.payload;
      }
    });
    this.loading = 'block';
    this.http_getAllSMS((data: any) => {
      this.loading = 'none';
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.allSMS = this.formatDate(data.payload);
      }
    });
  }

  getModalWithDropDown() {
    this.display = true;
    this.http_getSummaryReportTimeOpts((data: any) => {
      this.timeOpts = data.payload;
    });
    this.http_getSummaryReportWeeks((data: any) => {
      this.weeks = data.payload;
    });
    this.http_getSummaryReportMonth((data: any) => {
      this.month = data.payload;
    });
  }

  getTimeOpt() {
    if (this.reportOpts.selectedTimeOption['description'] === 'Day') {
    }
  }

  selectWeek(e) {
    this.reportOpts.selectedWeek = e.value;
  }

  selectMonth(e) {
    this.reportOpts.selectedMonth = e.value;
    if (this.reportOpts.selectedTimeOption['description'] === 'Day') {
      this.http_getSummaryReportDays(this.reportOpts.selectedMonth, data => {
        this.daysOfMonth = data.payload;
      });
    }
  }

  selectDay(e) {
    this.reportOpts.selectedDay = e.value;
  }

  buildReport() {
    let downURI = this.getSummaryURI();
    this.reportData = [[]];
    this.http_getSummaryReport(downURI, data => {
      this.report = data.payload;

      for (let i = 1, j = 0; i < this.report.length; i++) {
        this.reportData[j++] = this.report[i];
      }

      console.log(this.reportData);

      this.display = false;
      this.displayReport = true;
    });
  }

  downloadReport() {
    let downURI = this.getSummaryURI();

    let el = document.getElementById('summaryDowloadId');
    el.setAttribute('href', Globals.SERVER_ADDR + '/reporting/smsAccounting/summary/download' + downURI);
    el.setAttribute('download', 'report.csv');
    el.click();

    this.displayReport = false;
  }

  getSummaryURI() {
    let downURI = '?timeWindow=' + this.reportOpts.selectedTimeOption.timeWindow;
    if (this.reportOpts.selectedTimeOption.timeWindow == 'M') {
      downURI += '&year=' + this.reportOpts.selectedMonth.year +
        '&month=' + this.reportOpts.selectedMonth.month +
        '&week=' + 0 +
        '&day=' + 0 +
        '&start=' + 0 +
        '&end=' + 0;
    }
    if (this.reportOpts.selectedTimeOption.timeWindow == 'W') {
      downURI += '&year=' + this.reportOpts.selectedWeek.year +
        '&week=' + this.reportOpts.selectedWeek.week +
        '&month=' + 0 +
        '&day=' + 0 +
        '&start=' + 0 +
        '&end=' + 0;
    }
    if (this.reportOpts.selectedTimeOption.timeWindow == 'D') {
      downURI += '&year=' + this.reportOpts.selectedMonth.year +
        '&month=' + this.reportOpts.selectedMonth.month +
        '&day=' + this.reportOpts.selectedDay.dayOfYear +
        '&week=' + 0 +
        '&start=' + 0 +
        '&end=' + 0;
    }
    if (this.reportOpts.selectedTimeOption.timeWindow == 'DR') {
      downURI += '&start=' + +this.reportOpts.start +
        '&end=' + +this.reportOpts.end +
        '&year=' + 0 +
        '&month=' + 0 +
        '&day=' + 0 +
        '&week=' + 0;
    }

    downURI += '&clientId=' + this.cookiesService.get(Globals.COOKIES_CLIENT_ID);

    return downURI;
  }

  validateOpts() {
    let checkResult;
    if (this.reportOpts.selectedTimeOption.timeWindow == 'D') {
      checkResult = (!(this.reportOpts.selectedMonth && this.reportOpts.selectedDay))
    } else if (this.reportOpts.selectedTimeOption['description'] === 'Date Range') {
      checkResult = (!(this.reportOpts.start && this.reportOpts.end))
    } else {
      checkResult = (!(this.reportOpts.selectedWeek || this.reportOpts.selectedMonth || this.reportOpts.selectedDay))
    }
    return checkResult;
  }

  getSMS() {
    this.loading = 'block';
    switch (this.searchType.description) {
      case 'By country':
        this.http_getAllSMSByCountry(this.country.description, (data: any) => {
          this.loading = 'none';
          if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.allSMS = this.formatDate(data.payload);
          }
        });
        break;
      case 'By NAS ID':
        this.http_getAllSMSByNasId(this.nasid.description, (data: any) => {
          this.loading = 'none';
          if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.allSMS = this.formatDate(data.payload);
          }
        });
        break;
      case 'By period':
        this.http_getAllSMSByPeriod(+this.start, +this.end, (data: any) => {
          this.loading = 'none';
          if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
            this.allSMS = this.formatDate(data.payload);
          }
        });
        break;
    }
  }

  getDate(date) {
    return new Date(date);
  }

  clearObj(obj) {
    for (const prop of Object.getOwnPropertyNames(obj)) {
      if(prop !== 'selectedTimeOption') {
        obj[prop] = {};
      }
    }
  }

  selectRow(e) {}

  unselectRow() {}

  getWebSocketIdentifier(): string {
    return undefined;
  }

  private formatDate(payload: any) {
    for (let i = 0; i < payload.length; i++) {
      payload[i].createDate =
        payload[i].createDate !== null ? new Date(payload[i].createDate) : '';
      payload[i].verifyDate =
        payload[i].verifyDate !== null ? new Date(payload[i].verifyDate) : '';
    }
    return payload;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/sms-accounting/sms-accounting.component.ts